import { PageHeader } from "@nt/ui/page-header";
import { buttonVariants } from "@nt/ui/recipes";
import { ExternalLink } from "lucide-react";

import { CopyButton } from "@/components/copy-button";
import { Section } from "@/components/section";

export const FTC_DISCLOSURE =
  "I earn a commission if you buy through my link. This does not cost you anything extra.";
export const TERMS_URL = "https://nonresident.tax/partnership/terms/";

export const APPROVED_CLAIMS = [
  "Nonresident Tax helps non-US founders form and maintain a US company.",
  "Nonresident Tax prepares and files the annual federal forms a foreign-owned US LLC needs, such as Form 5472.",
  "Nonresident Tax is not a law firm or a CPA firm and does not give legal advice.",
];

export const NOT_ALLOWED = [
  "Promise tax results, savings or approval.",
  "Bid on our brand name in search ads.",
  "List us on coupon or cashback sites.",
  "Send spam or post fake reviews.",
  "Make claims that are not on the list you can use.",
];

export function Resources() {
  return (
    <>
      <PageHeader
        title="Resources"
        description="What to say, and how to say it."
      />
      <div className="grid items-start gap-6 md:grid-cols-2">
        <Section
          title="Disclosure text"
          description="The FTC requires a clear disclosure next to your link, in the same post or video. Use this text or your own words with the same meaning."
        >
          <div className="grid gap-3">
            <p className="rounded-control bg-muted px-3 py-2.5 text-sm text-foreground">
              {FTC_DISCLOSURE}
            </p>
            <div>
              <CopyButton text={FTC_DISCLOSURE} label="Copy disclosure" />
            </div>
          </div>
        </Section>
        <Section
          title="What you can say"
          description="Stick to these claims, in your own words."
        >
          <ul className="grid list-disc gap-2 pl-5 text-sm text-foreground">
            {APPROVED_CLAIMS.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </Section>
        <Section
          title="What you must not do"
          description="Not allowed for any partner. A violation voids the fee."
        >
          <ul className="grid list-disc gap-2 pl-5 text-sm text-foreground">
            {NOT_ALLOWED.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </Section>
        <Section
          title="Program terms"
          description="Everything above, and the rest of the rules, in full."
        >
          <a
            className={buttonVariants({ variant: "secondary", size: "sm" })}
            href={TERMS_URL}
            target="_blank"
            rel="noreferrer"
          >
            Read the full partner terms
            <ExternalLink aria-hidden />
            <span className="sr-only">(opens in a new tab)</span>
          </a>
        </Section>
      </div>
    </>
  );
}
